$.fn.hasAttr = function (name) {
	return this.attr(name) !== undefined;
};

// ******* Global Variable s*******

// *** Window
var ww = $(window).width();
var body = $("body");
// *** Header *** //
var header = $("header");
var height_header = header.outerHeight();
var menu_nav = header.find("nav");
var burger = header.find("#burger");
var overlay = $("#overlay");
// *** Nav Moble *** //
var nav_mobile = $(".nav-mobile");
var ul_Child = nav_mobile.find(".has-child");
var close_NB = nav_mobile.find("#close-button");
// *** Banner *** //
var pagesBanner = $("#page-banner");
var mainBanner = $("#main-banner");
// *** Footer *** //
$(".search-overlay").removeClass("active");
var mainSection = $("main");
var footer = $("footer");
// *** Component *** //
// Search
var btn_BackToTop = $(".back-to-top");
var btn_Group = $(".fixed-side-nav");

const setLineFirstTime = (liActive) => {
	if (liActive?.offset()?.left) {
		var line = header.find(".line");
		line.css({
			left: liActive.offset().left + "px",
			width: liActive.width() + "px",
		});
	}
};
const headerFunction = {
	onScroll: () => {
		var lastScrollTop = 0;
		$(window).on("scroll", function () {
			var st = $(this).scrollTop();
			if (st > lastScrollTop && st > height_header) {
				header.addClass("header-scroll");
				$(".search-overlay").addClass("header-scroll");
			} else {
				header.removeClass("header-scroll");
				$(".search-overlay").removeClass("header-scroll");
			}
			lastScrollTop = st;
			// removeSearch();
		});
	},

	movingLineOnLiActive: () => {
		var line = header.find(".line");
		var offset = header.find("nav").offset().left;
		var nav = header.find("nav");
		var liActive = header.find("li.active");
		if ($(".menu-item-387").length && $(".tax-documents").length) {
			header.find("li.menu-item-387").addClass("active");
			liActive = header.find("li.menu-item-387");
		}
		setLineFirstTime(liActive);
		setTimeout(() => {
			line.addClass("active");
		}, 350);
		var oldOffset, oldWidth;
		oldOffset = liActive.offset().left;
		oldWidth = liActive.width();
		nav.on("mouseenter", function () {
			var li = $(this).find("li");
			li.on("mousemove", function () {
				line.css({
					left: $(this).offset().left + "px",
					width: $(this).width() + "px",
				});
			});
			li.on("click", function () {
				line.css({
					left: $(this).offset().left + "px",
					width: $(this).width() + "px",
				});
				oldOffset = $(this).offset().left;
				oldWidth = $(this).width();
			});
		});
		nav.on("mouseleave", function () {
			line.css({
				left: oldOffset + "px",
				width: oldWidth + "px",
			});
		});
	},
	navMobileSlide: () => {
		burger.on("click", function () {
			burger.toggleClass("active");
			nav_mobile.toggleClass("active");
			overlay.toggleClass("active");
			body.toggleClass("ovh");
			header.toggleClass("navMobileOpen");
			$(".search-overlay").removeClass("active");
		});
		overlay.on("click", function () {
			burger.removeClass("active");
			nav_mobile.removeClass("active");
			overlay.removeClass("active");
			body.removeClass("ovh");
			header.removeClass("navMobileOpen");
			$(".search-overlay").removeClass("active");
		});
	},
	navMobileChild: () => {
		var liChild = nav_mobile.find("li.menu-item-has-children > a");
		//
		liChild.each(function () {
			$(this).attr("state", "unClick");
		});
		liChild.on("click", function (e) {
			if ($(this).attr("state") === "unClick") {
				e.preventDefault();
				console.log("unclick");
				$(this)
					.closest("ul")
					.find("li.menu-item-has-children > a")
					.attr("state", "unClick");
				$(this)
					.closest("ul")
					.find("li.menu-item-has-children > a")
					.siblings()
					.slideUp();
				$(this).attr("state", "click");
				$(this).siblings().slideDown();
			} else {
				console.log("click, page direction to" + $(this).attr("href"));
			}
		});
	},
	searchActive: () => {
		//
		$(".search-icon").on("click", function () {
			$(".search-overlay").addClass("active");
			header.addClass("navMobileOpen");
			setTimeout(() => {
				$(".search-overlay .searchbox input").trigger("focus");
			}, 500);
		});
		$(".search-overlay .searchbox input").on("focus", function () {
			$(this).parent().addClass("active");
		});
		$(".search-overlay .searchbox input").on("focusout", function () {
			$(this).parent().removeClass("active");
		});
		$(document).on("click", function (event) {
			var $trigger = $("header");
			var $trigger_2 = $(".search-overlay");
			if (
				$trigger !== event.target &&
				!$trigger.has(event.target).length &&
				$trigger_2 !== event.target &&
				!$trigger_2.has(event.target).length
			) {
				$(".search-overlay").removeClass("active");
				header.removeClass("navMobileOpen");
			}
		});
		$(".search-overlay .searchinput").keyup(function () {
			$(".search-overlay .wrapper").addClass("fixed-title");
			if ($(this).val() == "") {
				$(".search-overlay .wrapper").removeClass("fixed-title");
			}
		});
		// Press ESC to close Search
		setTimeout(() => {
			$(window).on("keyup", function (event) {
				var e = event.keyCode;
				if (e == 27) {
					$(".search-overlay").removeClass("active");
				}
			});
		}, 500);

		// Trigger click with 2 button
		$(".search-overlay .searchbox input[type='text']").keypress(function (
			n
		) {
			if (n.keyCode == 13)
				$(".searchbox button").trigger("click"), console.log("click");
		});
	},
	escBtn: () => {
		$(window).on("keyup", function (event) {
			var e = event.keyCode;
			if (e == 27) {
				nav_mobile.removeClass("active");
				header.removeClass("blur-content");
				burger.removeClass("active");
				overlay.removeClass("active");
				body.removeClass("ovh");
				header.removeClass("navMobileOpen");
			}
		});
	},
	init: () => {
		headerFunction.onScroll();
		headerFunction.navMobileSlide();
		headerFunction.navMobileChild();
		headerFunction.searchActive();
		headerFunction.escBtn();

	},
};

$("body").on("click", ".toggle-item .title", function (e) {
	e.preventDefault();
	let map = $(this).attr("data-map");
	$(".dealer-map-wrapper iframe").attr("src", map);
	if (!$(this).parent().hasClass("active")) {
		$(".toggle-item .article").slideUp();
		$(this).next().slideToggle();
		$(".toggle-item").removeClass("active");
		$(this).parent().addClass("active");
	} else {
		$(this).next().slideToggle();
		$(".toggle-item").removeClass("active");
	}
});
function toggleFunc() {
	//Support Item

	$(".product-zone-nav .toggle-nav").on("click", function () {
		$(this).next().slideToggle();
	});
	$(".drop-down .title em").on("click", function () {
		if ($(this).parents(".drop-down").hasClass("open-sub")) {
			$(".drop-down .mega-menu-wrap").slideUp();
			$(".drop-down").removeClass("open-sub");
		} else {
			$(".drop-down .mega-menu-wrap").slideUp();
			$(".drop-down").removeClass("open-sub");
			$(this).parent().next().slideDown();
			$(this).parents(".drop-down").addClass("open-sub");
		}
	});
	$(".drop-mega .title em").on("click", function () {
		if ($(this).parents(".drop-mega").hasClass("open-mega")) {
			$(".drop-mega .mega-menu-wrap").slideUp();
			$(".drop-mega").removeClass("open-mega");
		} else {
			$(".drop-mega .mega-menu-wrap").slideUp();
			$(".drop-mega").removeClass("open-mega");
			$(this).parent().next().slideDown();
			$(this).parents(".drop-mega").addClass("open-mega");
		}
	});
}

function tabActive() {
	$(".tab-navigation li a").on("click", function () {
		$(this).parents(".tab-navigation").find("li").removeClass("active");
		$(this).parents("li").addClass("active");

		var display = $(this).attr("data-type");
		$(this).parents("section").find(".tab-item").removeClass("active");
		$("#" + display).addClass("active");
	});
}
// *** Video Variable
function swiperInit() {
	var main_banner = new Swiper("#main-banner .swiper", {
		spaceBetween: 0,
		autoplay: {
			delay: 4500,
		},
		effect: "creative",
		creativeEffect: {
			prev: {
				shadow: true,
				translate: ["-20%", 0, -1],
			},
			next: {
				translate: ["100%", 0, 0],
			},
		},
		speed: 500,
		observer: true,
		observeParents: true,
		pagination: {
			el: "#main-banner .swiper-pagination",
			clickable: true,
		},
		navigation: {
			prevEl: "#main-banner .swiper-button-prev",
			nextEl: "#main-banner .swiper-button-next",
		},
	});
	var index_3 = new Swiper(".index-3 .swiper", {
		speed: 500,
		navigation: {
			prevEl: ".index-3 .swiper-button-prev",
			nextEl: ".index-3 .swiper-button-next",
		},
		slidesPerView: 1,
		spaceBetween: 10,
	});
	var index_4 = new Swiper(".index-4 .swiper", {
		speed: 500,
		navigation: {
			prevEl: ".index-4 .swiper-button-prev",
			nextEl: ".index-4 .swiper-button-next",
		},
		breakpoints: {
			1280: {
				slidesPerView: 5,
				spaceBetween: 30,
			},
			1024: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
			576: {
				slidesPerView: 3,
				spaceBetween: 10,
			},
			320: {
				slidesPerView: 2,
				spaceBetween: 5,
			},
		},
	});
	var index_5 = new Swiper(".home-project-swiper .swiper", {
		speed: 1205,
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: true,
		},
		centeredSlides: true,
		centeredSlidesBounds: true,
		slideToClickedSlide: true,
		lazy: {
			loadPrevNext: true,
		},
		breakpoints: {
			1280.1: {
				slidesPerView: 1.2,
				spaceBetween: 10,
				width: 260,
			},
			1024: {
				slidesPerView: 1,
				spaceBetween: 10,
			},
		},
		navigation: {
			prevEl: ".home-project-swiper .nav-arrow-prev",
			nextEl: ".home-project-swiper .nav-arrow-next",
		},
	});
	var homePartner = new Swiper(".home-swiper-partner .swiper", {
		speed: 1205,
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: true,
		},
		spaceBetween: 30,
		lazy: {
			loadPrevNext: true,
		},
		breakpoints: {
			320: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			576: {
				slidesPerView: 4,
			},
			1024.1: {
				slidesPerView: 5,
			},
			1280: {
				slidesPerView: 6,
			},
		},
		navigation: {
			prevEl: ".home-project-swiper .nav-arrow-prev",
			nextEl: ".home-project-swiper .nav-arrow-next",
		},
	});
	var homeCertificate = new Swiper(".swiper-certificate-thumb .swiper", {
		speed: 500,
		slideToClickedSlide: true,
		lazy: {
			loadPrevNext: true,
		},
		breakpoints: {
			320: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			576: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
			1024.1: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			1280: {
				slidesPerView: 3,
				grid: {
					rows: 2,
				},
				spaceBetween: 30,
			},
		},
		loop: false,
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: true,
		},
		navigation: {
			nextEl: ".swiper-certificate-thumb .nav-arrow-next",
			prevEl: ".swiper-certificate-thumb .nav-arrow-prev",
		},
	});
	var homeCertificateMain = new Swiper(".swiper-certificate-main .swiper", {
		speed: 500,
		slidesPerView: 1,
		spaceBetween: 30,
		thumbs: {
			swiper: homeCertificate,
		},
	});
	var historyPagination = new Swiper(".swiper-history-pagination .swiper", {
		speed: 500,
		slidesPerView: 1,
		spaceBetween: 30,
		breakpoints: {
			320: {
				slidesPerView: 2,
			},
			576: {
				slidesPerView: 4,
			},
			1024.1: {
				slidesPerView: 5,
			},
			1280: {
				slidesPerView: 6,
			},
		},
	});
	var historyImage = new Swiper(".swiper-history-main .swiper", {
		speed: 500,
		slidesPerView: 1,
		spaceBetween: 30,
		thumbs: {
			swiper: historyPagination,
		},
	});
	var historyYear = new Swiper(".swiper-history-year .swiper", {
		speed: 500,
		slidesPerView: 1,
		spaceBetween: 30,
		navigation: {
			nextEl: ".swiper-history-year .nav-arrow-next",
			prevEl: ".swiper-history-year .nav-arrow-prev",
		},
	});
	var historyTxt = new Swiper(".swiper-history-txt .swiper", {
		speed: 500,
		slidesPerView: 1,
		spaceBetween: 30,
	});
	historyImage.on("slideChange", function () {
		historyYear.slideTo(historyImage.activeIndex);
		historyTxt.slideTo(historyImage.activeIndex);
	});
	historyYear.on("slideChange", function () {
		historyImage.slideTo(historyYear.activeIndex);
		historyTxt.slideTo(historyYear.activeIndex);
	});
	historyTxt.on("slideChange", function () {
		historyYear.slideTo(historyTxt.activeIndex);
		historyImage.slideTo(historyTxt.activeIndex);
	});
	// **** Product **** //
	var product_other = new Swiper(".other-article-slide .swiper", {
		speed: 500,
		navigation: {
			prevEl: ".other-article-slide .swiper-button-prev",
			nextEl: ".other-article-slide .swiper-button-next",
		},
		breakpoints: {
			1280: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 15,
			},
			576: {
				slidesPerView: 2,
				spaceBetween: 15,
			},
			320: {
				slidesPerView: 2,
				spaceBetween: 5,
			},
		},
	});

	var researchThumb = new Swiper(".swiper-research-thumb .swiper", {
		speed: 500,
		breakpoints: {
			1280: {
				slidesPerView: 5,
				spaceBetween: 30,
				direction: "vertical",
			},
			1024: {
				slidesPerView: 5,
				spaceBetween: 20,
			},
			576: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
			320: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
		},
		navigation: {
			nextEl: ".swiper-research-thumb .nav-next",
			prevEl: ".swiper-research-thumb .nav-prev",
		},
	});
	var researchMain = new Swiper(".swiper-research-main .swiper", {
		speed: 500,
		slidesPerView: 1,
		spaceBetween: 30,
		thumbs: {
			swiper: researchThumb,
		},
	});
	//--Multi swiper instance--//
	$(".single-swiper .swiper").each(function (index, element) {
		var $this = $(this);
		$this.addClass("single-instance-" + index);
		$this
			.parent()
			.find(".nav-arrow-prev")
			.addClass("btn-prev-single-" + index);
		$this
			.parent()
			.find(".nav-arrow-next")
			.addClass("btn-next-single-" + index);
		$this
			.parent()
			.find(".swiper-pagination")
			.addClass("pagination-instance-" + index);

		var swiper = new Swiper(".single-instance-" + index, {
			speed: 1205,
			autoplay: {
				delay: 3000,
				pauseOnMouseEnter: true,
			},
			lazy: {
				loadPrevNext: true,
			},
			speed: 750,
			observer: true,
			spaceBetween: 30,
			observeParents: true,
			slidesPerView: 1,
			navigation: {
				nextEl: ".btn-next-single-" + index,
				prevEl: ".btn-prev-single-" + index,
			},
			pagination: {
				el: ".pagination-instance-" + index,
				type: "bullets",
				clickable: true,
			},
		});
	});
	$(".trinity-swiper .swiper").each(function (index, element) {
		var $this = $(this);
		$this.addClass("tri-instance-" + index);
		$this
			.parent()
			.find(".nav-arrow-prev")
			.addClass("btn-prev-tri-" + index);
		$this
			.parent()
			.find(".nav-arrow-next")
			.addClass("btn-next-tri-" + index);

		var swiper = new Swiper(".tri-instance-" + index, {
			speed: 1205,
			autoplay: {
				delay: 3000,
				pauseOnMouseEnter: true,
			},
			lazy: {
				loadPrevNext: true,
			},
			speed: 750,
			observer: true,
			spaceBetween: 30,
			observeParents: true,
			breakpoints: {
				200: {
					slidesPerView: 1,
					spaceBetween: 10,
				},
				450: {
					slidesPerView: 2,
				},
				769: {
					slidesPerView: 3,
				},
				1200: {
					slidesPerView: 3,
				},
			},
			navigation: {
				nextEl: ".btn-next-tri-" + index,
				prevEl: ".btn-prev-tri-" + index,
			},
		});
	});

	$(".four-swiper .swiper").each(function (index, element) {
		var $this = $(this);
		$this.addClass("instance-four" + index);
		$this
			.parent()
			.find(".nav-arrow-prev")
			.addClass("btn-prev-" + index);
		$this
			.parent()
			.find(".nav-arrow-next")
			.addClass("btn-next-" + index);

		var swiper = new Swiper(".instance-four" + index, {
			speed: 1205,
			autoplay: {
				delay: 3000,
				pauseOnMouseEnter: true,
			},
			lazy: {
				loadPrevNext: true,
			},
			speed: 750,
			observer: true,
			spaceBetween: 30,
			observeParents: true,

			breakpoints: {
				200: {
					slidesPerView: 1,
				},
				360: {
					slidesPerView: 2,
				},
				769: {
					slidesPerView: 3,
				},
				1280: {
					slidesPerView: 4,
				},
			},
			navigation: {
				nextEl: ".btn-next-" + index,
				prevEl: ".btn-prev-" + index,
			},
		});
	});
	$(".four-swiper-no-gap .swiper").each(function (index, element) {
		var $this = $(this);
		$this.addClass("instance-four" + index);
		$this
			.parent()
			.find(".nav-arrow-prev")
			.addClass("btn-prev-" + index);
		$this
			.parent()
			.find(".nav-arrow-next")
			.addClass("btn-next-" + index);

		var swiper = new Swiper(".instance-four" + index, {
			speed: 1205,
			autoplay: {
				delay: 3000,
				pauseOnMouseEnter: true,
			},
			lazy: {
				loadPrevNext: true,
			},
			speed: 750,
			observer: true,
			observeParents: true,

			breakpoints: {
				200: {
					slidesPerView: 2,
				},
				576: {
					slidesPerView: 2,
				},
				769: {
					slidesPerView: 3,
				},
				1280: {
					slidesPerView: 4,
				},
			},
			navigation: {
				nextEl: ".btn-next-" + index,
				prevEl: ".btn-prev-" + index,
			},
		});
	});
	$(".double-swiper .swiper").each(function (index, element) {
		var $this = $(this);
		$this.addClass("instance-quad" + index);
		$this
			.parent()
			.find(".nav-arrow-prev")
			.addClass("btn-prev-" + index);
		$this
			.parent()
			.find(".nav-arrow-next")
			.addClass("btn-next-" + index);

		var swiper = new Swiper(".instance-quad" + index, {
			speed: 1205,
			autoplay: {
				delay: 3000,
				pauseOnMouseEnter: true,
			},
			lazy: {
				loadPrevNext: true,
			},
			speed: 750,
			observer: true,
			spaceBetween: 30,
			observeParents: true,

			breakpoints: {
				200: {
					slidesPerView: 1,
				},
				576: {
					slidesPerView: 2,
				},
			},
			navigation: {
				nextEl: ".btn-next-" + index,
				prevEl: ".btn-prev-" + index,
			},
		});
	});
	$(".project-swiper .swiper").each(function (index, element) {
		var $this = $(this);
		$this.addClass("instance-project-" + index);
		$this
			.parents(".project-swiper")
			.find(".swiper-pagination")
			.addClass("pagination-instance-project-" + index);

		var projectIndex = new Swiper(".instance-project-" + index, {
			speed: 1205,
			autoplay: {
				delay: 3000,
				pauseOnMouseEnter: true,
			},
			lazy: {
				loadPrevNext: true,
			},
			speed: 750,
			observer: true,
			spaceBetween: 30,
			observeParents: true,

			breakpoints: {
				320: {
					slidesPerView: 1,
					spaceBetween: 10,
				},
				420: {
					slidesPerView: 2,
					spaceBetween: 10,
				},
				768: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 4,
				},
				1280: {
					slidesPerView: 3.2,
				},
			},
			pagination: {
				el: ".pagination-instance-project-" + index,
				type: "progressbar",
				renderCustom: function (swiper, current, total) {
					return current + "/" + (total - 1);
				},
			},
			on: {
				init: function () {
					let temp = $(".instance-project-" + index).find(
						".swiper-slide"
					).length;
					console.log(temp);
					$(".instance-project-" + index)
						.parents(".project-swiper")
						.find(".last-index")
						.text(temp);
				},
			},
		});
	});
}

function autoSlideNextOnThumbSlide(initSwiper, element, thumb) {
	let activeIndex = initSwiper.activeIndex + 1;
	let activeSlide = document.querySelector(
		`${element} ${thumb} .swiper-slide:nth-child(${activeIndex})`
	);
	let nextSlide = document.querySelector(
		`${element} ${thumb} .swiper-slide:nth-child(${activeIndex + 1})`
	);
	let prevSlide = document.querySelector(
		`${element} ${thumb} .swiper-slide:nth-child(${activeIndex - 1})`
	);

	if (nextSlide && !nextSlide.classList.contains("swiper-slide-visible")) {
		initSwiper.thumbs.swiper.slideNext();
	} else if (
		prevSlide &&
		!prevSlide.classList.contains("swiper-slide-visible")
	) {
		initSwiper.thumbs.swiper.slidePrev();
	}
}

function expandItem() {
	// Filter Load
	var hasLoadBtn = $("[has-expand-btn]");
	hasLoadBtn.each(function () {
		var $this = $(this);
		var expandBtn = $(this).find(".expand-btn");
		var list = $(this).find(".expand-item").length;
		var count;
		var countMobile = $(this).attr("item-count-mobile");
		countMobile != undefined && countMobile != 0 && ww < 576
			? (count = Number($(this).attr("item-count-mobile")))
			: (count = Number($(this).attr("item-count")));
		var expand = Number($(this).attr("item-expand"));

		//=// Init
		function init(initValue, thisFunction) {
			if (list >= initValue) {
				thisFunction
					.find(".expand-item")
					.slice(0, initValue)
					.slideDown({
						complete: function () {
							$(this).addClass("done-animated");
						},
					});
			} else {
				thisFunction.find(".expand-item").slideDown();
				thisFunction.find(".expand-item").addClass("done-animated");
			}
			if (list == 0 || list <= initValue) {
				expandBtn.hide();
			}
		}
		init(count, $this);

		// Click
		function expandBtnInit(initCount, thisFunction) {
			count = initCount + expand <= list ? initCount + expand : list;
			thisFunction
				.closest(hasLoadBtn)
				.find(".expand-item")
				.slice(0, count)
				.slideDown({
					complete: function () {
						$(this).addClass("done-animated");
					},
				});
			// console.log(count);
			if (count == list) {
				thisFunction.slideUp();
			}
		}
		expandBtn.on("click", function (e) {
			e.preventDefault();
			expandBtnInit(count, $(this));
		});
	});
}

const globalJS = {
	autoFillNoImage: () => {
		setTimeout(() => {
			$("img").each(function () {
				if ($(this).hasAttr("data-src")) {
					if ($(this).attr("data-src") === "") {
						$(this).attr("data-src", "/no-image.png");
						$(this).attr("src", "/no-image.png");
						$(this).addClass("noImage");
					}
				} else if ($(this).hasAttr("src")) {
					if ($(this).attr("src") === "") {
						$(this).attr("src", "/no-image.png");
						$(this).addClass("noImage");
					}
				}
			});
		}, 150);
	},

	hoverItem: () => {


		$(".about-1 .item").on("mouseenter", function () {
			let tab = $(this).attr("data-type");

			$(".about-1 .item").removeClass("is-active");
			$(".about-1 .item").css("opacity", .4);
			$(this).addClass("is-active");
			$(this).css("opacity", 1);
			// Reset all paths' opacity to default
			$(".about-1 .svg-center .svg-hover").css("fill-opacity", 0.6);

			// Set the hovered tab's associated path opacity to 1
			$(".about-1 .svg-center ." + tab).css("fill-opacity", 1);
		});
		$(".about-1 .item").on("mouseleave", function () {
	
			$(".about-1 .svg-center .svg-hover").css("fill-opacity", 1);
			$(".about-1 .item").css("opacity", 1);

		});

	},

	autoAppend: () => {
		var appendId = $("[id*='autoAppend-']");
		appendId.each(function (e) {
			var id = $(this).attr("id").slice(11);
			// console.log(id);
			$(this).appendTo("[id*='autoAppendHere-" + id + "']");
			var curHeight = $(this).get(0).scrollHeight;
		});
	},
	autoClone: () => {
		var cloneId = $("[id*='autoClone-']");
		cloneId.each(function (e) {
			var id = $(this).attr("id").slice(10);
			// console.log(id);
			$(this)
				.clone()
				.appendTo("[id*='autoCloneHere-" + id + "']");
		});
	},
	setBackground: () => {
		var position = ["", "top", "left", "right", "bottom"];
		jQuery.each(position, function (index, item) {
			//
			//
			$(`[setBackground${item}]`).each(function () {
				var background = $(this).attr("setBackground" + item);
				$(this).css({
					"background-size": "cover",
					"background-position": `${item} center`,
					"background-image": `url(${background})`,
				});
			});
		});
	},
	scrollToTop: () => {
		$(window).on("scroll", function () {
			if (
				$(this).scrollTop() >= mainBanner.outerHeight() ||
				$(this).scrollTop() >= pagesBanner.outerHeight()
			) {
				btn_Group.addClass("active");
			} else {
				btn_Group.removeClass("active");
			}
		});
		btn_BackToTop.on("click", function () {
			$("html,body").animate({
				scrollTop: 0,
			});
		});
	},
	inputButtonSubmit: () => {
		$("input[type='submit']").each(function () {
			if ($(this).parent().is(".btn")) {
				//
				$(this).parent().addClass("has-input-submit");
				$(this).parent().attr("data-title", $(this).val());
			}
		});
	},
	checkListItem: () => {
		$("main ul").each(function () {
			$(this).addClass("list-item-added");
		});
	},
	init: () => {
		globalJS.autoFillNoImage();
		globalJS.autoAppend();
		globalJS.autoClone();
		globalJS.setBackground();
		globalJS.scrollToTop();
		globalJS.inputButtonSubmit();
		globalJS.checkListItem();
		globalJS.hoverItem();

	},
};

function counterUpNumber() {
	$(".counter").counterUp({
		delay: 100,
		time: 2000,
	});
}

function activeCommonNav() {
	$(".common-nav li").each(function () {
		if ($(this).hasClass("active")) {
			$(this).closest("ul").scrollLeft($(this).position().left);
		}
	});
}

function numberWithCommas(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

function setElementToScreen() {
	var screenRight = $(".screen-right");
	var screenLeft = $(".screen-left");
	const position = ($(window).width() - $(".container").width()) / 2;
	if ($(window).width() >= 1280) {
		if (screenRight.length) {
			//
			screenRight.each(function () {
				$(this).css({
					"margin-right": -position + "px",
				});
			});
		}
		if (screenLeft.length) {
			//
			screenLeft.each(function () {
				$(this).css({
					"margin-left": -position + "px",
				});
			});
		}
	}
}

var delayLayoutElement = [
	".nav-mobile nav > ul > li",
	".index-10 .list .title,.index-10 .list .item",
];
const setDelayLayoutElement = () => {
	jQuery.each(delayLayoutElement, function (index, item) {
		$(`body ${item}`).each(function (e) {
			e += 1;
			$(this).css({
				"transition-delay": e * 0.1 + "s",
			});
		});
	});
};
function imageMap() {
	$(".image-map-wrapper img[usemap]").maphilight();
	$(".image-map-wrapper img[usemap]").rwdImageMaps();
	$(".tooltip").tooltipster({
		contentCloning: true,
		theme: "tooltipster-customer-2",
		maxWidth: 260,
		minWidth: 193,
		animation: "fade",
		trigger: "click",
		positionTracker: true,
	});
}

function tableClass() {
	if ($(".product-information table").length) {
		$("table").wrap("<div class='table-responsive'></div>");
	}
	if ($(".news-detail .fullcontent table").length) {
		$(".news-detail .fullcontent table").wrap(
			"<div class='table-wrapper'></div>"
		);
	}
}

function stickyNav() {
	if ($(".sticky-nav").length) {
		$(".sticky-nav").scrollToFixed({
			zIndex: 99,
			marginTop: $("header").outerHeight(),
		});
	}

	$(window)
		.scroll(function () {
			var scrollDistance = $(window).scrollTop();
			// Assign active class to nav links while scolling
			$(".about-section-wrapper .about-section-id").each(function (i) {
				if (
					$(this).position().top -
					$(".sticky-nav").outerHeight() -
					$("header").outerHeight() -
					1 <=
					scrollDistance
				) {
					$(".sticky-nav li.active").removeClass("active");
					$(".sticky-nav li").eq(i).addClass("active");
				}
			});
		})
		.scroll();
	$(".sticky-nav a").on("click", function (event) {
		if (this.hash !== "") {
			let offset =
				$("header").outerHeight() + $(".sticky-nav").outerHeight();
			var hash = this.hash;
			$("html, body").animate(
				{
					scrollTop: $(hash).offset().top - offset,
				},
				800,
				function () {
					// window.location.hash = hash;
				}
			);
		} // End if
	});
}

$(document).ready(function () {
	// ---***--- Global JS ---***---
	imageMap();
	globalJS.init();

	// ---***--- Header ---***---
	try {
		headerFunction.init();
	} catch (error) { }

	// ---***--- Body ---***---
	swiperInit();
	counterUpNumber();
	expandItem();
	activeCommonNav();
	setElementToScreen();
	setDelayLayoutElement();
	stickyNav();
	tableClass();
	toggleFunc();
	tabActive();

	if ($(window).width() >= 1280) {
		menuHover();
	}

	// ---***--- Fancybox ---***---
	Fancybox.bind("[data-fancybox]", {});
});

$(window).resize(function () {
	setLineFirstTime(
		header.find("nav >ul > li.active"),
		header.find("li.active")
	);
	$("html").css({
		"--header-height": header.outerHeight() + "px",
	});
});
$(window).trigger("resize");

// ***** Preload ***** //
document.onreadystatechange = () => {
	if (document.readyState === "complete") {
		/**
		 * Turn on when Deploy
		 */
		// headerFunction.movingLineOnLiActive();
		$("html").css({
			"--header-height": header.outerHeight() + "px",
		});
		$("body").addClass("initial-body");
	}
};
function menuHover() {
	$(".drop-mega .mega-menu-wrap .nav-col-menu a").on(
		"mouseenter",
		function () {
			let img = $(this).attr("data-image");
			$(".drop-mega .mega-menu-wrap .img-wrap img").attr("src", img);
		}
	);
}
$(window).on("resize", function () {
	var win = $(this); //this = window
	if (win.width() >= 1280) {
		menuHover();
	}
	if (win.width() <= 576) {
		$("header .button-wrapper").appendTo(".nav-mobile");
	}
});

try {
	const counterUp = window.counterUp.default;

	const callback = (entries) => {
		entries.forEach((entry) => {
			const el = entry.target;
			if (entry.isIntersecting && !el.classList.contains("is-visible")) {
				counterUp(el, {
					duration: 2000,
					delay: 100,
				});
				el.classList.add("is-visible");
			}
		});
	};

	const IO = new IntersectionObserver(callback, { threshold: 1 });

	const el = document.querySelectorAll(".counter");

	el.forEach((counter) => {
		IO.observe(counter);
	});

	window.onload = function () {
		// let's go!
		if ($(".dealer-list").length) {
			$(".toggle-item:first-child .title").trigger("click");
		}
	};
} catch (error) { }
